import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { OrdersProvider } from './context/OrdersContext';
import ProtectedRoute from './layout/ProtectedRoute';
import AppLayout from './layout/AppLayout';
import Login from './pages/Login/Login';
import Signup from './pages/Signup/Signup';
import ConfirmAccountPage from './pages/Signup/ConfirmAccountPage';
import ForgotPin from './pages/ForgotPin/ForgotPin';
import OrderQueue from './pages/OrderQueue/OrderQueue';
import POS from './pages/POS/POS';
import Catalog from './pages/Catalog/Catalog';
import Inventory from './pages/Inventory/Inventory';
import Promotions from './pages/Promotions/Promotions';
import Events from './pages/Events/Events';
import DeliveryFees from './pages/DeliveryFees/DeliveryFees';
import OrderLookup from './pages/OrderLookup/OrderLookup';
import StoreSettings from './pages/StoreSettings/StoreSettings';
import Profile from './pages/Profile/Profile';
import Admin from './pages/Admin/Admin';
import DeletionRequests from './pages/Admin/DeletionRequests';
import SupportRequests from './pages/Admin/SupportRequests';
import BulkOnboard from './pages/Catalog/BulkOnboard';
import ReturnsQueue from './pages/Returns/ReturnsQueue';
import SubscriptionPacks from './pages/Subscriptions/Packs';
import SubscriptionRunSheet from './pages/Subscriptions/RunSheet';
import DriverHome from './pages/Driver/DriverHome';
import DriverRideDetail from './pages/Driver/DriverRideDetail';
import DriverProofOfDelivery from './pages/Driver/DriverProofOfDelivery';
import DriverCompleteDelivery from './pages/Driver/DriverCompleteDelivery';
import DriverFailDelivery from './pages/Driver/DriverFailDelivery';
import DriverReturnDetail from './pages/Driver/DriverReturnDetail';
import DriverRideHistory from './pages/Driver/DriverRideHistory';
import DriverSupport from './pages/Driver/DriverSupport';
import ProductSuggestions from './pages/ProductSuggestions/ProductSuggestions';
import Analytics from './pages/Analytics/Analytics';
import ReportsHistoryPage from './pages/Analytics/ReportsHistoryPage';

function App() {
  return (
    <AuthProvider>
      <OrdersProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/signup/confirm" element={<ConfirmAccountPage />} />
            <Route path="/forgot-pin" element={<ForgotPin />} />
            <Route
              path="/driver"
              element={(
                <ProtectedRoute allowedGroups={['Delivery']}>
                  <DriverHome />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/driver/history"
              element={(
                <ProtectedRoute allowedGroups={['Delivery']}>
                  <DriverRideHistory />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/driver/support"
              element={(
                <ProtectedRoute allowedGroups={['Delivery']}>
                  <DriverSupport />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/driver/rides/:orderId"
              element={(
                <ProtectedRoute allowedGroups={['Delivery']}>
                  <DriverRideDetail />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/driver/rides/:orderId/proof"
              element={(
                <ProtectedRoute allowedGroups={['Delivery']}>
                  <DriverProofOfDelivery />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/driver/rides/:orderId/complete"
              element={(
                <ProtectedRoute allowedGroups={['Delivery']}>
                  <DriverCompleteDelivery />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/driver/rides/:orderId/fail"
              element={(
                <ProtectedRoute allowedGroups={['Delivery']}>
                  <DriverFailDelivery />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/driver/returns/order/:orderId"
              element={(
                <ProtectedRoute allowedGroups={['Delivery']}>
                  <DriverReturnDetail />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/driver/returns/:requestId"
              element={(
                <ProtectedRoute allowedGroups={['Delivery']}>
                  <DriverReturnDetail />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/"
              element={(
                <ProtectedRoute allowedGroups={['Admin', 'Ops']}>
                  <AppLayout />
                </ProtectedRoute>
              )}
            >
              <Route index element={<OrderQueue />} />
              <Route path="pos" element={<POS />} />
              <Route path="products" element={<Catalog />} />
              <Route path="products/bulk" element={<BulkOnboard />} />
              <Route path="suggestions" element={<ProductSuggestions />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="returns" element={<ReturnsQueue />} />
              <Route path="subscriptions" element={<SubscriptionRunSheet />} />
              <Route path="subscriptions/packs" element={<SubscriptionPacks />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="analytics/reports" element={<ReportsHistoryPage />} />
              <Route path="promotions" element={<Promotions />} />
              <Route path="events" element={<Events />} />
              <Route path="delivery-fees" element={<DeliveryFees />} />
              <Route path="order-lookup" element={<OrderLookup />} />
              <Route path="support" element={<SupportRequests />} />
              <Route path="store-settings" element={<StoreSettings />} />
              <Route path="profile" element={<Profile />} />
              <Route
                path="admin"
                element={(
                  <ProtectedRoute allowedGroups={['Admin']}>
                    <Admin />
                  </ProtectedRoute>
                )}
              />
              <Route
                path="admin/deletion-requests"
                element={(
                  <ProtectedRoute allowedGroups={['Admin']}>
                    <DeletionRequests />
                  </ProtectedRoute>
                )}
              />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </OrdersProvider>
    </AuthProvider>
  );
}

export default App;
